export const defaultValues = {
  contact: {
    province: "Ontario"
  }
}



// WEBPACK FOOTER //
// ./src/components/new-mortgage-wizard/options.js